/**
 * Scroll management for BaseModal
 */

/**
 * Get scrollbar width
 * @returns {number} Scrollbar width in pixels
 */
export function getSizeScrollbar() {
    const scrollDiv         = document.createElement('div');
    scrollDiv.style.cssText = 'width: 100px; height: 100px; overflow: scroll; position: absolute; top: -9999px;';
    document.body.appendChild(scrollDiv);
    const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    return scrollbarWidth;
}

/**
 * Control scroll behavior
 * @param {Object} modal - Modal instance
 * @param {string} toggle - 'enable' or 'disable'
 */
export function scrollBehaviour(modal, toggle) {
    // If disableScroll is false, return early
    if (!modal.config.disableScroll) return;

    // Get the scroll size and set CSS custom property
    const scrollSize = getSizeScrollbar();

    // Modify the document styles based on the toggle parameter
    switch (toggle) {
        case 'enable':
            document.documentElement.classList.remove('bm-modal-open');
            // Remove CSS custom property
            document.documentElement.style.removeProperty('--scrollbar-width');
            break;
        case 'disable':
            document.documentElement.classList.add('bm-modal-open');
            // Set CSS custom property for scrollbar width
            document.documentElement.style.setProperty('--scrollbar-width', `${scrollSize}px`);
            break;
        default:
    }
}
